var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"icon-mypage",attrs:{"to":_vm.to}},[(_vm.src)?_c('img',{staticClass:"icon",attrs:{"src":_vm.src,"height":"100%"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }